import React from 'react';
import ReactDOM from 'react-dom/client';
import { io } from "socket.io-client";
import { createStore, applyMiddleware } from 'redux';
import {Provider} from 'react-redux';
import App from './jsx/App';
import mainReducer from './redux/mainReducer';
import thunk from 'redux-thunk';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.js';
import { get } from './utils/getVisitId';

const { REACT_APP_SOCKET_URL = window.location.origin } = process.env;


window.socket = io(REACT_APP_SOCKET_URL, {
  reconnection: true,
  auth: (cb) => {
    cb({
      id: get()
    });
  }
});
window.addEventListener("focus", () => window.socket.connect());

window.store = createStore(mainReducer, applyMiddleware(thunk));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={window.store}>
      <App />
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
